import { Link, useParams } from "react-router-dom";
import styles from "./SubscribePage.module.css";

export default function SubscribeSuccessPage() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className={styles.page}>
      <div className={`${styles.container} ${styles.successContainer}`}>
        <div className={styles.successIcon}>🎉</div>
        <h1 className={styles.successTitle}>You're subscribed!</h1>
        <p className={styles.successMessage}>
          Thanks for subscribing! Check your email for your private podcast feed URL. Add it to your
          favorite podcast app to start listening to premium content.
        </p>
        <Link to={`/subscribe/${slug}`} className={styles.backLink}>
          ← Back to podcast
        </Link>
      </div>
    </div>
  );
}
